import { BindCardFlowTypeEnum } from '@/api/bank-card/types';

export enum BindCardResultEnum {
  /** 绑卡成功 */
  SUCCESS = 0,
  /** 绑卡失败 */
  FAILURE = 1,
  /** 绑卡处理中 */
  PROCESS = 2,
}

export interface IBankData {
  /** 哈啰银行编码 */
  bankCode: string;
  /** 通联银行编码 */
  thirdBankCode?: string;
  /** 银行名称 */
  bankName: string;
  /** 银行 logo */
  bankLogo: string;
}

export interface IBindApplyQuery {
  /** 渠道 ID */
  commodityId: string;
  /** 绑卡申请场景类型 非必传，目前只有BindCardFlowTypeEnum.CREDIT场景需要 */
  bindCardFlowType?: BindCardFlowTypeEnum;
  /** 自营 B 资方 */
  capitalCode: string;
  /** 三方银行编码，注意不是哈啰的 */
  thirdBankCode: string;
  /** 回跳url */
  callBackUrl: string;
}
export interface IBindQuickBankListParams {
  /** 产品ID */
  productId: string;
  /** 资方编码 */
  capitalCode?: string;
}
